import {useCurrentUserStore} from "@/stores/current-user";

export const permissionList = {
  READ_USER: 'read user',
  UPDATE_USER: 'update user',
  CREATE_USER: 'create user',
  READ_USER_LOG: 'read user log',

  READ_CUSTOMER: 'read customer',
  CREATE_CUSTOMER: 'create customer',
  UPDATE_CUSTOMER: 'update customer',
  DELETE_CUSTOMER: 'delete customer',

  READ_WAREHOUSE: 'read warehouse',
  CREATE_WAREHOUSE: 'create warehouse',
  UPDATE_WAREHOUSE: 'update warehouse',
  TRANSFER_ITEM_WAREHOUSE: 'transfer item warehouse',
  MANAGE_WAREHOUSE_CONSUMABLES: 'manage warehouse consumables',

  READ_PRODUCT: 'read product',
  CREATE_PRODUCT: 'create product',
  UPDATE_PRODUCT: 'update product',
  DELETE_PRODUCT: 'delete product',
  READ_PRODUCT_COGS: 'read product cogs',

  INSERT_STOCK: 'insert stock',
  READ_STOCK_LOG: 'read stock log',

  READ_COMPOSITION: 'read composition',
  CREATE_COMPOSITION: 'create composition',

  READ_PRODUCTION: 'read production',
  CREATE_PRODUCTION: 'create production',
  UPDATE_PRODUCTION: 'update production',

  READ_ORDER: 'read order',
  CREATE_ORDER: 'create order',
  UPDATE_ORDER: 'update order',
  DELETE_ORDER: 'delete order',
  REFUND_ORDER: 'refund order',
  READ_ORDER_LOG: 'read order log',

  READ_EXPENSE: 'read expense',
  CREATE_EXPENSE: 'create expense',
  UPDATE_EXPENSE: 'update expense',
  DELETE_EXPENSE: 'delete expense',
  PURCHASE_RAW_MATERIAL: 'purchase raw material',

  READ_SALES_REPORT: 'read sales report',

  SUPER_USER: 'super user', // for super user only
}

function isSuperUser() {
  const userStore = useCurrentUserStore()
  if (!userStore.user) {
    return false
  }
  return userStore.user.roles.filter(item => item.name === 'Owner').length > 0;

}

export function canAccess(permission: string | null) {
  const userStore = useCurrentUserStore()

  if (isSuperUser() || permission === null) {
    return true
  }

  return userStore.allPermissions.filter(item => item.name === permission).length > 0
}

export function haveAllAccess(permissions: string[]) {
  const userStore = useCurrentUserStore()

  if (isSuperUser()) {
    return true
  }

  const allPermissions = userStore.allPermissions

  for (const permission in permissions) {
    if (allPermissions.filter(item => item.name === permission).length === 0) {
      return false
    }
  }

  return true
}

export function haveOneAccess(permissions: string[]) {
  const userStore = useCurrentUserStore()

  if (isSuperUser()) {
    return true
  }

  const allPermissions = userStore.allPermissions

  for (const permission of permissions) {
    if (allPermissions.filter(item => item.name === permission).length > 0) {
      return true
    }
  }

  return false
}

export function isSalesAccount() {
  const userStore = useCurrentUserStore()

  if (!isSuperUser()) {
    return false
  }

  return !!userStore.user?.referrer_code
}
